export default [
    {
        path: '/terms',
        name: 'terms',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Termos',
            icon: 'mdi-file-document-edit-outline',
            breadcrumbs: [
                { text: 'Lista de termos', disabled: true }
            ]
        }
    }
]